import styled from '@emotion/styled';
import { Paragraph } from 'react-magma-dom';
import { COLORS } from '../../constants';

export const StyledBlackParagraph = styled(Paragraph)`
  color: ${COLORS.black};
`;

export const StyledIntroductionToHybridParagraph = styled.h1`
  font-size: 28px;
  color: ${COLORS.black};
`;
